import { Immutable } from "immer";
import React from "react";

import { templates } from "@reactivated";

import { StreamField } from "@thelabnyc/thelabui/src/components/StreamField";

import { compareHeroComponentsMap } from "../../blocks/componentMaps";

export const ComparePageHero = (
    props: Immutable<{ page: templates.ComparePageVariantCTemplate["page"] }>,
): React.JSX.Element | null => {
    if (!props.page.hero) {
        return null;
    }
    return (
        <StreamField
            tagName={React.Fragment}
            value={props.page.hero.value}
            components={compareHeroComponentsMap}
        />
    );
};
